"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "schema", {
  enumerable: true,
  get: function get() {
    return _schema.default;
  }
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _Message = _interopRequireDefault(require("../../components/Message"));

var _Tooltip = _interopRequireDefault(require("../../components/Tooltip"));

var _focusWithoutScrolling = _interopRequireDefault(require("../../utils/focusWithoutScrolling"));

var _useTranslations = _interopRequireDefault(require("../../utils/useTranslations"));

var _useUniqueId = _interopRequireDefault(require("../../utils/useUniqueId"));

var _Containers = require("./Containers");

var _InputLabel = _interopRequireDefault(require("./InputLabel"));

var _RequiredIcon = _interopRequireDefault(require("../RequiredIcon"));

var _HelpMessage = _interopRequireDefault(require("./HelpMessage"));

var _schema = _interopRequireDefault(require("./schema"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function InputField(props, targetRef) {
  var children = props.children,
      _props$cursor = props.cursor,
      cursor = _props$cursor === void 0 ? 'text' : _props$cursor,
      disabled = props.disabled,
      _props$hideLabel = props.hideLabel,
      hideLabel = _props$hideLabel === void 0 ? false : _props$hideLabel,
      helpMessage = props.helpMessage,
      IconComponent = props.icon,
      secondaryElement = props.secondaryElement,
      id = props.id,
      inputContainerRef = props.inputContainerRef,
      label = props.label,
      labelIdProp = props.labelId,
      maxLength = props.maxLength,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onKeyDown = props.onKeyDown,
      overflow = props.overflow,
      readOnly = props.readOnly,
      required = props.required,
      requiredMessageProp = props.requiredMessage,
      showCharacterCount = props.showCharacterCount,
      style = props.style,
      value = props.value,
      warningMessage = props.warningMessage,
      _props$isTextArea = props.isTextArea,
      isTextArea = _props$isTextArea === void 0 ? false : _props$isTextArea,
      _props$multiple = props.multiple,
      multiple = _props$multiple === void 0 ? false : _props$multiple,
      rest = _objectWithoutProperties(props, ["children", "cursor", "disabled", "hideLabel", "helpMessage", "icon", "secondaryElement", "id", "inputContainerRef", "label", "labelId", "maxLength", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "overflow", "readOnly", "required", "requiredMessage", "showCharacterCount", "style", "value", "warningMessage", "isTextArea", "multiple"]);

  var fallbackTargetRef = (0, _react.useRef)(null);
  var finalTargetRef = targetRef || fallbackTargetRef;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFocused = _useState2[0],
      setIsFocused = _useState2[1];

  var _useState3 = (0, _react.useState)(value ? value.length : 0),
      _useState4 = _slicedToArray(_useState3, 2),
      contentLength = _useState4[0],
      setContentLength = _useState4[1];

  var onInputContainerClickHandler = function onInputContainerClickHandler(event) {
    if (!disabled && !readOnly) {
      if (!isFocused) {
        // @ts-ignore
        (0, _focusWithoutScrolling.default)(finalTargetRef.current);
        setIsFocused(true);
      }

      if (onClick) {
        onClick(event);
      }
    }
  }; // The blur and focus state handlers are required because you can't use the
  // CSS pseudo-selector `:focus-within` in IE.


  var onBlurHandler = function onBlurHandler(event) {
    setIsFocused(false);

    if (onBlur) {
      onBlur(event);
    }
  };

  var onFocusHandler = function onFocusHandler(event) {
    if (!disabled && !readOnly) {
      setIsFocused(true);

      if (onFocus) {
        onFocus(event);
      }
    }
  };

  var onChangeHandler = function onChangeHandler(event) {
    if (event && event.target) {
      var targetValue = event.target.value;
      setContentLength(targetValue ? targetValue.length : 0);
    }

    if (onChange) {
      onChange(event);
    }
  };

  var targetId = (0, _useUniqueId.default)(id, 'input-field-target-');
  var labelId = labelIdProp || "".concat(targetId, "-label");
  var translate = (0, _useTranslations.default)();
  var requiredMessage = translate(requiredMessageProp, 'textField.requiredMessage');
  return _react.default.createElement(_Containers.InputFieldContainer, {
    overflow: overflow,
    style: style
  }, _react.default.createElement(_Containers.InputContainer, {
    cursor: cursor,
    hiddenLabel: hideLabel,
    disabled: disabled,
    hasWarning: !!warningMessage,
    isFocused: isFocused,
    readOnly: readOnly,
    ref: inputContainerRef,
    onClick: onInputContainerClickHandler,
    onKeyDown: onKeyDown,
    isTextArea: isTextArea,
    multiple: multiple
  }, IconComponent && _react.default.createElement(_Containers.IconContainer, {
    hiddenLabel: hideLabel
  }, _react.default.createElement(IconComponent, null)), _react.default.createElement(_Containers.InputInnerContainer, {
    hasIcon: !!IconComponent,
    hiddenLabel: hideLabel
  }, _react.default.createElement(_InputLabel.default, {
    disabled: disabled,
    htmlFor: targetId,
    hidden: hideLabel,
    id: labelId,
    readOnly: readOnly,
    onClick: function onClick(event) {
      event.preventDefault();
    }
  }, _react.default.createElement("span", null, label, required && _react.default.createElement(_Tooltip.default, {
    placement: "top",
    target: _react.default.createElement(_RequiredIcon.default, {
      "aria-label": requiredMessage
    })
  }, requiredMessage))), children(_objectSpread({}, rest, {
    'aria-labelledby': labelId,
    disabled: disabled,
    id: targetId,
    maxLength: maxLength,
    onBlur: onBlurHandler,
    onChange: onChangeHandler,
    onClick: onInputContainerClickHandler,
    onFocus: onFocusHandler,
    readOnly: readOnly,
    ref: finalTargetRef,
    required: required,
    value: value
  }))), secondaryElement && _react.default.createElement(_Containers.IconContainer, {
    rightPlacement: true
  }, secondaryElement)), warningMessage && _react.default.createElement(_Message.default, {
    intent: "warning"
  }, warningMessage), _react.default.createElement(_HelpMessage.default, {
    contentLength: contentLength,
    showCharacterCount: showCharacterCount,
    helpMessage: helpMessage,
    maxLength: maxLength
  }));
}

var InputFieldWithRef = (0, _react.forwardRef)(InputField);
InputFieldWithRef.displayName = 'InputField';
InputFieldWithRef.propTypes = _objectSpread({}, _schema.default.propTypes, {
  icon: _propTypes.default.elementType
});
var _default = InputFieldWithRef;
exports.default = _default;